import React from 'react'
import {Box, BoxProps,Text} from '../../../vanilla'
import {ModalNavigationProps} from '../../../types/ui'
import {Promotion, PromotionalBadgeText} from '../../../store/ProductStore'
import {ReactElement} from 'react-markdown/lib/react-markdown'
import {observer} from 'mobx-react-lite'
import {usePromotion} from '../../../store/hooks/usePromotion'
import {NearPromoItem} from './nearPromoItem'
interface NearPromoProps extends BoxProps<'div'> {
  promotion?: Promotion | null
  bundle?: PromotionalBadgeText | null
  disableInteraction?: boolean
  children?: ReactElement
  onNavigate?: (url: string) => void
  search?: boolean
  cartDrawer?: boolean
  modalNavigationProps?: ModalNavigationProps
  hitId?: string
  displayBadgeText?: boolean
}

export const NEAR_PROMO_LIMIT = {
  MINI_BASKET: 2,
  BASKET: 2,
  PLP: 2,
  PDP: 3,
  SEARCH_SUGGESTIONS: 2
}

export const NearPromo = observer((props: NearPromoProps) => {
  const {
    promotion,
    bundle,
    disableInteraction,
    children,
    onNavigate,
    search,
    cartDrawer,
    modalNavigationProps,
    hitId = '',
    displayBadgeText = false,
    ...rest
  } = props
  const promo = usePromotion(promotion?.ID)

  if (!promo && !bundle) return null

  const isValidMultiTiered =
    promo?.groups[0]?.req &&
    promo?.groups[0]?.req.length > 1 &&
    promo?.groups[0]?.req.length === promo?.discountValue?.length &&
    promotion?.ladderDeals

  const deals =
    isValidMultiTiered && promotion?.ladderDeals
      ? promotion.ladderDeals
      : [
          {
            msg: promotion?.msg,
            multibuyUnitPrice: promotion?.multibuyUnitPrice,
            unitPriceMsg: promotion?.unitPriceMsg
          }
        ]

  return (
    <>
      {deals.map((deal, i) => (
        <React.Fragment key={`${hitId}-${promotion?.ID}`}>
          <NearPromoItem
            promotion={promotion}
            bundle={bundle}
            disableInteraction={disableInteraction}
            onNavigate={onNavigate}
            search={search}
            cartDrawer={cartDrawer}
            modalNavigationProps={modalNavigationProps}
            hitId={hitId}
            displayBadgeText={displayBadgeText}
            promoMsg={deal.msg}
            multibuyUnitPrice={deal.multibuyUnitPrice}
            unitPriceMsg={deal.unitPriceMsg}
            {...rest}
          />
          {deals.length > 1 && i === 0 && (
            <Box
              gap="4px"
              marginTop={search ? '4px' : undefined}
              marginLeft={search ? undefined : '4px'}
            >
              <Text
                variant="text1"
                color="textMuted"
                style={{fontSize: '12px', fontWeight: '400'}}
                display="flex"
                lineHeight="none"
              >
                Also included in
              </Text>
            </Box>
          )}
        </React.Fragment>
      ))}
    </>
  )
})
